import styled from "styled-components";
// import { theme } from '../../../theme'
// import { MdPlayCircleOutline } from "react-icons/md";
import { MdCreate } from "react-icons/md";

const Item = styled.div`
  height: 22.564rem;
  border-radius: 8px 6px 0px 0px;
  display: flex;
  flex-direction: column;
 

  .top {
      width: 100%;
      height: 19.251rem;
      margin: 0;
      position: relative;

      .subject-image {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
  }

  .bottom {
    width: 100%;
    // background-color: black;
    // height: 34.04px;
    background-color: #FFFFFF;
    padding: 0 1.1rem;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    border-radius: 0px 0px 6px 6px;
    display:flex;
    flex-direction: row;
    justify-content:space-between;
    align-items:center;
    flex: 1;

    .subject-title {
        font-weight: 700;
        font-size: 1.4rem;
        color: #3B3B42;
        white-space: nowrap; 
        width: 12rem; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }

    .icon {
        cursor: pointer;
        display: flex;
        color: #D6D7D8;
    }
}
`
const Overlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(33, 150, 243, 0.8);
    border-radius: 8px 6px 0px 0px;
    z-index: 2;
    cursor: pointer;
    display: flex;
    align-items:center;
    justify-content: center;

    svg {
        width:4rem;
        height:4rem;
        color: white;
    }
`

const LibraryMediaItem = ({ subject, imgUrl, icon }) => {
    const isTeacher = window.location.pathname.includes('teacher')
    return (
        <Item>

            <div className="top">
                <Overlay>{icon}</Overlay>
                <img className="subject-image" src={imgUrl} alt={subject} />

            </div>
            <div className="bottom">
                <span className="subject-title">{subject}</span>
                <span className="icon">{isTeacher && <MdCreate />}</span>
            </div>

        </Item>
    )
}

export default LibraryMediaItem
